var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGermanyFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#010101;}.cls-4{fill:#db1f26;}.cls-5{fill:#fdcd0a;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: -0.43,
    width: 1500,
    height: 1000
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag-of-Germany") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: -0.43,
    width: 1500,
    height: 1000
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 332.9,
    width: 1500,
    height: 666.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 666.24,
    width: 1500,
    height: 333.33
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermanyFlag);
export default __webpack_public_path__ + "static/media/germany_flag.cec763d5a65326e400d6ea0d07a67845.svg";
export { ForwardRef as ReactComponent };